import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogCancel,
} from "../../../../../../ui/AlertDialog/AlertDialog";
import { Button } from "../../../../../../ui/Button";
import { t } from "i18next";
import React, { useEffect } from "react";
import { useFetch } from "../../../../../../hooks/useFetch";

type Props = {
  id: string;
  downtimeId: string | undefined;
  isDeleteOpen: boolean;
  closeModal: Function;
  refreshChanges: Function;
  closeModalOnDelete: Function;
};

const DeleteReason = ({ id, downtimeId, isDeleteOpen, closeModal, refreshChanges, closeModalOnDelete }: Props) => {
  const [
    {
      response: deleteResponse,
      isLoading: deleteIsLoading,
      error: deleteError,
    },
    doFetchItemDelete,
  ] = useFetch(`/directories/equipment_items/${id}/changes/${downtimeId}`);

  useEffect(() => {
    if (isDeleteOpen) {
      closeModal();
      closeModalOnDelete();
      refreshChanges();
    }
  }, [deleteResponse]);

  const onDelete = () => {
    doFetchItemDelete({
      method: "DELETE",
    });
  };

  const openStateChange = () => {
    if (isDeleteOpen) closeModal();
  };

  return (
    <AlertDialog open={isDeleteOpen} onOpenChange={openStateChange}>
      <AlertDialogContent style={{ maxWidth: 450 }} className="gap-0">
        <AlertDialogTitle>Удалить причину простоя</AlertDialogTitle>
        <AlertDialogDescription className="text-base">Вы уверены, что хотите удалить причину простоя?</AlertDialogDescription>

        <div className="flex justify-between mt-4">
          <Button variant={"destructive"} size={"md"} className="px-3" onClick={onDelete}>
            {t("delete")}
          </Button>
          <AlertDialogCancel className="h-8">{t("cancel")}</AlertDialogCancel>
        </div>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default DeleteReason;
